import React from 'react';

import Image from 'next/image';

import Button from '@components/common/Button/Button';
import useTranslateLpc from '@components/common/hooks/useTranslateLpc';

import css from './BannerMessageDescription.module.scss';

type BannerMessageProps = {
    onEdit: () => void;
};

const EmptyDescription = ({ onEdit }: BannerMessageProps) => {
    const { t } = useTranslateLpc(['lpc-pot']);

    return (
        <div className={css.container_banner_description}>
            <div className={css.container_banner_description__first_message}>
                <h5>
                    {t('informations.description-banner-label')}
                    <Image
                        height={24}
                        width={24}
                        className={css.container_banner_description__first_message__img}
                        src="/front-static/icons/display/handwriting.svg"
                        alt="writting"
                    />
                </h5>
            </div>
            <Button onClick={() => onEdit()} customClass={css.container_banner_description__cta} variant={'white'}>
                {t('informations.description-banner-button')}
            </Button>
        </div>
    );
};
export default EmptyDescription;
